module.exports = ":root{--lui-avatar-size:var(--lui-reduced-control-height);--lui-avatar-border-color:var(--lui-gradient-start);--lui-avatar-border-color-hover:var(--lui-gradient-start);--lui-avatar-border-color-active:var(--lui-gradient-start)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-avatar/theme/lui-avatar.global.scss
// module id = 167
// module chunks = 0 1 37